/** Künstliche Sponsor-Markenzeichen (SVG) — kein externes Asset nötig. */
export default function SponsorMark({ brand, size = 40, className = "", title }) {
  if (!brand) return null;
  const mark = brand.mark || "?";
  const colors = brand.colors || { primary: "#334155", secondary: "#94a3b8", ink: "#f8fafc" };
  const shape = brand.shape || "shield";
  const s = Number(size) || 40;
  const label = title || brand.name || mark;

  let path = null;
  if (shape === "hex") {
    path = "M50 6 L90 28 L90 72 L50 94 L10 72 L10 28 Z";
  } else if (shape === "circle") {
    path = null;
  } else if (shape === "bolt") {
    path = "M58 8 L22 54 H48 L38 92 L78 42 H52 Z";
  } else if (shape === "banner") {
    path = "M8 22 H92 V70 L50 88 L8 70 Z";
  } else {
    // shield
    path = "M50 6 L88 22 V52 C88 72 70 88 50 94 C30 88 12 72 12 52 V22 Z";
  }

  return (
    <span
      className={`inline-flex items-center justify-center shrink-0 ${className}`}
      style={{ width: s, height: s }}
      title={label}
      aria-label={label}
    >
      <svg viewBox="0 0 100 100" width={s} height={s} role="img">
        <defs>
          <linearGradient id={`sg-${brand.key || mark}`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={colors.primary} />
            <stop offset="100%" stopColor={colors.secondary} />
          </linearGradient>
        </defs>
        {shape === "circle" ? (
          <circle cx="50" cy="50" r="44" fill={`url(#sg-${brand.key || mark})`} stroke={colors.ink} strokeWidth="3" />
        ) : (
          <path d={path} fill={`url(#sg-${brand.key || mark})`} stroke={colors.ink} strokeWidth="3" />
        )}
        <text
          x="50"
          y="56"
          textAnchor="middle"
          fontSize={mark.length > 2 ? 22 : 28}
          fontWeight="800"
          fill={colors.ink}
          fontFamily="ui-sans-serif, system-ui, sans-serif"
        >
          {mark}
        </text>
      </svg>
    </span>
  );
}

/** Mini-Trikot mit Sponsor-Platzierung (Ärmel / Brust). */
export function JerseyPreview({ brand, placement = "jersey", className = "" }) {
  if (!brand) return null;
  const colors = brand.colors || { primary: "#334155", secondary: "#94a3b8", ink: "#f8fafc" };
  const showChest = placement === "jersey" || placement === "name";
  const showSleeve = placement === "sleeve" || placement === "jersey" || placement === "name";

  return (
    <div className={`relative w-20 h-24 ${className}`} aria-hidden>
      <div
        className="absolute inset-x-2 top-3 bottom-1 rounded-b-lg"
        style={{ background: `linear-gradient(160deg, ${colors.primary}, ${colors.secondary})` }}
      />
      {/* Schultern */}
      <div className="absolute left-0 top-4 w-3 h-7 rounded-l" style={{ background: colors.primary }} />
      <div className="absolute right-0 top-4 w-3 h-7 rounded-r" style={{ background: colors.primary }} />
      <div className="absolute left-1/2 -translate-x-1/2 top-2 w-8 h-3 rounded-b-full bg-black/20" />
      {showSleeve ? (
        <div className="absolute left-0.5 top-5">
          <SponsorMark brand={brand} size={14} />
        </div>
      ) : null}
      {showChest ? (
        <div className="absolute left-1/2 top-10 -translate-x-1/2">
          <SponsorMark brand={brand} size={28} />
        </div>
      ) : (
        <div className="absolute left-1/2 top-12 -translate-x-1/2 text-[10px] font-black opacity-40" style={{ color: colors.ink }}>
          {brand.mark}
        </div>
      )}
    </div>
  );
}
